import classnames from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import styles from './Label.module.scss';

export interface ILabelProps extends IBaseProps, React.HTMLAttributes<HTMLElement> {
  /** Changes the HTML element used to display the component. */
  as?: 'label' | 'legend' | 'span';
  /** Changes the color of the text for the group variant only. */
  color?: string;
  /** Set to true if label is paired with a disabled field and should look visually disabled. */
  disabled?: boolean;
  /** The for attribute value on the HTML label element. Assigned the ID of the form element it should be bound to. */
  htmlFor?: string;
  /** The unique html ID for the <label> element. */
  id?: string;
  /** Changes the visual display of the label. */
  variant?: string;
  /** determines if the label is required for aria-required attribute */
  required?: boolean;
  inputMode?: 'none' | 'search' | 'numeric' | 'text' | 'email' | 'tel' | 'url' | 'decimal';
}

export const getAriaRequired = (required) => {
  if (required) {
    return true;
  }
  // this need to return false if the user provides false or if the prop is undefined
  return false;
};

export const Label: React.FC<ILabelProps> = ({
  as = 'label',
  children,
  className,
  color,
  dataTest,
  disabled,
  htmlFor,
  id,
  variant,
  required,
  ...rest
}) => {
  const classes = {
    [styles.label]: variant !== 'group',
    [styles.groupLabel]: variant === 'group',
    [styles.colorDark]: color === 'dark',
    [styles.disabled]: disabled
  };

  const HtmlElement = as;

  return (
    <HtmlElement
      aria-required={getAriaRequired(required)}
      className={classnames(classes, className)}
      data-test={dataTest}
      id={id}
      {...(HtmlElement === 'legend' || HtmlElement === 'span' ? null : { htmlFor })}
      {...rest}
    >
      {children}
    </HtmlElement>
  );
};
